import { render } from "./OtpModal.vue?vue&type=template&id=2dc050ea&scoped=true"
import script from "./OtpModal.vue?vue&type=script&lang=js"
export * from "./OtpModal.vue?vue&type=script&lang=js"

import "./OtpModal.vue?vue&type=style&index=0&id=2dc050ea&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2dc050ea"]])

export default __exports__